import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hn from "./locales/hn.json";
import as from "./locales/as.json";
import bn from "./locales/bn.json";
import gu from "./locales/gu.json";
import kn from "./locales/kn.json";
import ml from "./locales/ml.json";
import mr from "./locales/mr.json";
import ory from "./locales/ory.json";
import pa from "./locales/pa.json";
import ta from "./locales/ta.json";
import te from "./locales/te.json";
import ur from "./locales/ur.json";
import fr from "./locales/fr.json";
import ir from "./locales/ir.json";
import gm from "./locales/gm.json";
import it from "./locales/it.json";
import po from "./locales/po.json";
import sw from "./locales/sw.json";
import ro from "./locales/ro.json";

// the translations
const resources = {
    en: {
        translation: en, // English
    },
    hn: {
        translation: hn, // Hindi
    },
    as: {
        translation: as, // Assamese
    },
    bn: {
        translation: bn, // Bengali
    },
    gu: {
        translation: gu, // Gujarati
    },
    kn: {
        translation: kn, // Kannada
    },
    ml: {
        translation: ml, // Malayalam
    },
    mr: {
        translation: mr, // Marathi
    },
    ory: {
        translation: ory, // Odia
    },
    pa: {
        translation: pa, // Punjabi
    },
    ta: {
        translation: ta, // Tamil
    },
    te: {
        translation: te, // Telugu
    },
    ur: {
        translation: ur, // Urdu
    },
    fr: {
        translation: fr, // French
    },
    ir: {
        translation: ir, // Irish
    },
    gm: {
        translation: gm, // German
    },
    it: {
        translation: it, // Italian
    },
    po: {
        translation: po, // Polish
    },
    sw: {
        translation: sw, // Swedish
    },
    ro: {
        translation: ro, // Romanian
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
